import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/invoice.js';
export const InvokeCreateInvoiceRequestSchema = z.object({
    invoice: InvoiceSchema.pick({ total: true, customer: true }),
    entityId: CornSchema,
    additional: z.record(z.string(), z.unknown()).optional(),
    requestActor: z.string(),
});
export const InvokeCreateInvoiceResponseSchema = z.object({ invoice: InvoiceSchema });
